var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "poster-from-timeline-component", class: _vm.className },
    [
      _vm.video_file_url
        ? _c("div", { staticClass: "timeline_thumbnail" }, [
            _c("video", {
              ref: "video",
              attrs: {
                src: _vm.video_file_url,
                type: "video/mp4",
                controls: ""
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn-browse btn-sm",
                on: {
                  click: function($event) {
                    return _vm.setTimelineThumbnail()
                  }
                }
              },
              [_vm._v("Select this frame")]
            ),
            _vm._v(" "),
            _c("canvas", { ref: "canvas", staticClass: "hide" })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }